<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24" >
            <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择日期" v-decorator="['date', validatorRules.date]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['doctorName', validatorRules.doctorName]" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
         <a-col :span="24" >
            <a-form-item label="总号量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['total', validatorRules.total]" placeholder="请输入总号量" style="width: 100%"/>
         </a-form-item>
     </a-col>
              <a-col :span="24" >
                 <a-form-item label="时间段" :labelCol="labelCol" :wrapperCol="wrapperCol">
                   <a-input v-decorator="['vartPart', validatorRules.vartPart]" placeholder="请输入时间段" style="width: 100%"/>
              </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item label="状态 0-出诊，1-不出诊" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['status']" ></j-switch>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="上下午时间对应时间段" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="appointmentTimesTable.loading"
          :columns="appointmentTimesTable.columns"
          :dataSource="appointmentTimesTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JSwitch from '@/components/jeecg/JSwitch'

  export default {
    name: 'AppointmentForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JSwitch,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
validatorRules: {
        date: {
        rules: [
            { required: true, message: '请输入日期!'},
        ]
        },
        doctorName: {
        rules: [
            { required: true, message: '请输入医生姓名!'},
        ]
        },
        total: {
        rules: [
            { required: true, message: '请输入总号量!'},
        ]
        },
        vartPart: {
        rules: [
            { required: true, message: '请输入时间段!'},
        ]
        },
},
        refKeys: ['appointmentTimes', ],
        tableKeys:['appointmentTimes', ],
        activeKey: 'appointmentTimes',
        // 上下午时间对应时间段
        appointmentTimesTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '开始工作时间',
              key: 'startWorkTime',
              type: FormTypes.datetime,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '结束工作时间',
              key: 'endWorkTime',
              type: FormTypes.datetime,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '号量',
              key: 'status',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
             {
                  title: '时间段',
                  key: 'vartPart',
                  type: FormTypes.input,
                  width:"200px",
                  placeholder: '请输入${title}',
                  defaultValue: '',
                  validateRules: [{ required: true, message: '${title}不能为空' }],
                },
             // {
            //   title: '时间段',
            //   key: 'vartPart',
            //   type: FormTypes.,
            //   dictCode:"",
            //   width:"250px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            //   validateRules: [{ required: true, message: '${title}不能为空' }],
            // },

          ]
        },
        url: {
          add: "/appointment/appointment/add",
          edit: "/appointment/appointment/edit",
          queryById: "/appointment/appointment/queryById",
          appointmentTimes: {
            list: '/appointment/appointment/queryAppointmentTimesByMainId'
          },
        }
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.appointmentTimesTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'date','doctorName','total','status')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.appointmentTimes.list, params, this.appointmentTimesTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          appointmentTimesList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'date','doctorName','total','status','vartPart'))
     },

    }
  }
</script>

<style scoped>
</style>